import { ErrorComponent, MainFooter, MainHeader, PageLayout } from "shared";
import { useAppScope } from "master/contexts";
import { MwcdLogoComopent, OfflineText } from "..";
import { OfflineImage } from "assets/images/OfflineImage";

export const OfflinePage = ({ onOfflineReload }) => {
    const { lanSettings } = useAppScope();

    return (
        <>
            <MainHeader />
            <PageLayout isPageEmpty={true} isBreadCrumbsRequired={false}>
                <div className="d-flex justify-content-end pb-3 mt-3">
                    <MwcdLogoComopent customClass="logo-group-mwcd_PD marati_logo_empty_page" />
                </div>
                <div style={{ height: "90%" }}>
                    <ErrorComponent
                        title={`${OfflineText.title[lanSettings?.lan || "en"]}`}
                        message={`${OfflineText.description[lanSettings?.lan || "en"]}`}
                        image={OfflineImage}
                        btnLabel={`${OfflineText.button[lanSettings?.lan || "en"]}`}
                        onClick={onOfflineReload}
                    />
                </div>
            </PageLayout>
            <MainFooter />
        </>
    );
};
